$shm_hitalama_skills_editor $mol_page
	entry $shm_hitalama_skills_entry
	minimal_width 720
	attr *
		^
		editing <= editing? false
	title \Скилл
	tools /
		<= Edit $mol_check_icon
			hint \Редактировать скилл
			enabled <= editable false
			checked? <=> editor_open? false
			Icon <= Edit_icon $mol_icon_pencil
		<= Close $mol_link
			hint \Закрыть скилл
			arg * skill null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Name $mol_labeler
			title \Название
			content <= name_content /$mol_view_content
		<= Skill_name $mol_labeler
			title \id
			content <= id_content /$mol_view_content
		<= Description $mol_labeler
			title \Когда применять
			content <= description_content /$mol_view_content
		<= Instruction $mol_labeler
			title \Инструкция
			content <= instruction_content /$mol_view_content
		<= Status
	Name_input $mol_string
		enabled <= editable
		value? <=> entry_title? \
	Skill_name_input $mol_string
		enabled <= editable
		value? <=> skill_name? \
	Description_input $mol_textarea
		enabled <= editable
		value? <=> description? \
	Instruction_input $mol_textarea
		enabled <= editable
		value? <=> instruction? \
	Description_text $mol_text
		text <= description? \
	Instruction_text $mol_text
		text <= instruction? \
	Status $mol_status
		status <= status \
	Source* $shm_hitalama_skills_source
		entry <= entry
		path <= identity* \
		enabled <= editable
